import includes from "lodash/includes";
import styled from "styled-components";
const SIZES = {
    ICON_WIDTH: 16
};
export default {
    Container: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["bgColor", "borderColor", "blockWidth", "blockHeight"], prop)
    }) `
    display: grid;
    grid-template-columns: ${SIZES.ICON_WIDTH}px 1fr;
    align-items: center;
    ${({ blockWidth }) => blockWidth && `width: ${blockWidth}px;`}
    ${({ blockHeight }) => blockHeight && `height: ${blockHeight}px;`}

    border-radius: ${({ theme }) => theme["border-radius-base"]};
    background-color: ${({ theme, bgColor }) => theme[bgColor] || bgColor};
    ${({ theme, borderColor }) => borderColor && `border: 1px solid ${theme[borderColor] || borderColor};`}
  `,
    Icon: styled.i.withConfig({
        shouldForwardProp: (prop) => !includes(["color"], prop)
    }) `
    color: ${({ theme, color }) => (color ? theme[color] || color : "unset")};
    width: ${SIZES.ICON_WIDTH}px;
  `
};
